
import Cookies from 'js-cookie'
import store from '@/store'

const TokenKey = 'Admin-Token'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken () {
  store.commit('SET_TOKEN', '')
  return Cookies.remove(TokenKey)
}

const storageKey = 'Admin-LocalStorage-'

export function setStorage (key, data) {
  if (typeof data === 'object') {
    data = JSON.stringify(data)
  }
  return localStorage.setItem(storageKey + key, data)
}

export function getStorage (key) {
  return localStorage.getItem(storageKey + key)
}

export function removeStorage (key) {
  return localStorage.removeItem(storageKey + key)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js